import React, { useState } from "react";
import FullImageModal from "../../full-image-modal";
import Thumbnail from "../../thumbnail";

const OptionField = ({
  dimensionIndex,
  questionIndex,
  optionIndex,
  optionValue,
  optionsType,
  handleChange,
  isChecked,
  selection,
}) => {
  const ImageOptionField = () => {
    const { label, url } = optionValue;
    const thumbnailRoute = require(`../../../assets/img/${url}`).default;

    const [modalIsVisible, setModalIsVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState();

    const clickThumbnailHandler = (event, image) => {
      event.preventDefault();
      setModalIsVisible(true);
      setSelectedImage(image);
    };

    const closeModalHandler = () => setModalIsVisible(false);

    const renderOptionField = () => (
      <div className="form-check">
        <input
          className="form-check-input"
          type={selection === "single" ? "radio" : "checkbox"}
          id={`options_${dimensionIndex}_${questionIndex}_${optionIndex}`}
          name={`options_${dimensionIndex}_${questionIndex}`}
          value={label}
          onChange={handleChange}
          checked={isChecked}
        />
        <label
          className="form-check-label"
          htmlFor={`options_${dimensionIndex}_${questionIndex}_${optionIndex}`}
        >
          {label}
        </label>
      </div>
    );

    return (
      <div className="mx-1">
        <Thumbnail
          name={renderOptionField()}
          image={thumbnailRoute}
          onClickThumbnail={(event) => clickThumbnailHandler(event, thumbnailRoute)}
        />
        <FullImageModal
          id={`options_${dimensionIndex}_${questionIndex}_${optionIndex}`}
          image={selectedImage}
          isVisible={modalIsVisible}
          onCloseModal={closeModalHandler}
        />
      </div>
    );
  };

  const DefaultOptionField = () => (
    <div className="form-check">
      <input
        className="form-check-input"
        type={selection === "single" ? "radio" : "checkbox"}
        id={`options_${dimensionIndex}_${questionIndex}_${optionIndex}`}
        name={`options_${dimensionIndex}_${questionIndex}`}
        value={optionValue}
        onChange={handleChange}
        checked={isChecked}
      />
      <label
        className="form-check-label"
        htmlFor={`options_${dimensionIndex}_${questionIndex}_${optionIndex}`}
      >
        {optionValue}
      </label>
    </div>
  );

  switch (optionsType) {
    case "images":
      return <ImageOptionField />;
    case "default":
    default:
      return <DefaultOptionField />;
  }
};

export default OptionField;
